import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import PublicLayout from './pages/PublicLayout.jsx';
import FormViewPage from './pages/FormViewPage.jsx';
import ConfirmationPage from './pages/ConfirmationPage.jsx';
import PaymentsReturnPage from './pages/PaymentsReturnPage.jsx';
import GiftCertificateViewPage from "~/public/pages/GiftCertificateViewPage";
import InvoiceViewPage from "~/public/pages/InvoiceViewPage";
import ErrorPage from '~/pages/ErrorPage.jsx';
const router = createBrowserRouter([
    {
        path: '/',
        element: <PublicLayout />,
        errorElement: <ErrorPage isPublic={true} />,
        children: [
            {
                path: '/form/:formId',
                element: <FormViewPage />,
            },
            {
                path: '/confirmation/:token',
                element: <ConfirmationPage />,
            },
            {
                path: '/gift-certificate/:token',
                element: <GiftCertificateViewPage />,
            },
            {
                path: '/invoice/:token',
                element: <InvoiceViewPage />,
            },
        ],
    },
    {
        path: '/payments/return/:businessId/:type/:id',
        element: <PaymentsReturnPage />,
    },
]);

export { router };
